import flagKeys from '@/constants/flagKeys';
import RefundsPolicies from '@/views/YourCoin/RefundsPolicies/index.vue';
import { Route } from '../route.model';

const refundReturnPolicy = new Route(
  '/coin/policies',
  'refund_return_policy',
  RefundsPolicies,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    navbar: {
      name: 'Refund & Return Policy', // TODO apply i18n
      icon: 'refund',
      description:
        'In case of returns or exchanges, rewards to members can be delayed until after the return policy expires.'
    },
    pageView: {
      eventLabel: 'Refund Policy'
    }
  }
);

export { refundReturnPolicy };
export default refundReturnPolicy;
